export class GlobalConstants {
    public static globalScopes = [
        {
            name: 'All',
            value: '1'
        },
        {
            name: 'International',
            value: '2'
        },
        {
            name: 'USA',
            value: '3'
        }
    ];

    public static getScopeName(scopeValue): string {
        let scopeName = '';
        this.globalScopes.forEach(item => {
            if (item.value === ('' + scopeValue)) {
                scopeName = item.name;
            }
        });
        return scopeName;
    }
}
